// Decorative brand-colored background shapes (NEVER on text).
// Blobs sit behind content at low opacity; small shapes accent titles/images.

const BRAND = {
  red: "#FF3123",
  orange: "#FC8529",
  cyan: "#3CC0E7",
  blue: "#1A49F7",
};

export function Blob({ color = "blue", className = "", size = 420, opacity = 0.12 }) {
  return (
    <span
      aria-hidden="true"
      className={`decor-blob ${className}`}
      style={{
        width: size,
        height: size,
        backgroundColor: BRAND[color] || color,
        opacity,
      }}
    />
  );
}

// Small solid accent dot
export function Dot({ color = "orange", className = "", size = 12 }) {
  return (
    <span
      aria-hidden="true"
      className={`inline-block shrink-0 rounded-full ${className}`}
      style={{ width: size, height: size, backgroundColor: BRAND[color] || color }}
    />
  );
}

// Thin accent ring
export function Ring({ color = "cyan", className = "", size = 60 }) {
  return (
    <span
      aria-hidden="true"
      className={`pointer-events-none absolute rounded-full ${className}`}
      style={{ width: size, height: size, border: `2px solid ${BRAND[color] || color}` }}
    />
  );
}

// Discreet wavy section separator
export function WaveDivider({ color = "#F3F6FF", flip = false }) {
  return (
    <div aria-hidden="true" className="pointer-events-none -mb-px w-full leading-[0]" style={{ transform: flip ? "rotate(180deg)" : "none" }}>
      <svg viewBox="0 0 1440 80" preserveAspectRatio="none" className="h-12 w-full md:h-20">
        <path d="M0,40 C240,90 480,0 720,32 C960,64 1200,88 1440,40 L1440,80 L0,80 Z" fill={color} />
      </svg>
    </div>
  );
}
